// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { Navigate, useNavigate } from "react-router-dom";

// const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);

//   // Load user from localStorage when the app starts
//   useEffect(() => {
//     const storedUser = localStorage.getItem("user");
//     if (storedUser) {
//       setUser(JSON.parse(storedUser)); // Restore user session
//     }
//   }, []);

//   const login = (username, password) => {
//     // Fetch passwords from environment variables
//     const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;
//     const tutorPassword = process.env.REACT_APP_TUTOR_PASSWORD;
//     const wardenPassword = process.env.REACT_APP_WARDEN_PASSWORD;

//     let loggedInUser = null;

//     // Simplified login logic
//     if (username === 'admin' && password === adminPassword) {
//       loggedInUser = { username, role: 'Admin' };
//     } else if (username === 'tutor' && password === tutorPassword) {
//       loggedInUser = { username, role: 'Tutor' };
//     } else if (username === 'warden' && password === wardenPassword) {
//       loggedInUser = { username, role: 'Warden' };
//     } else {
//       return false; // Invalid credentials
//     }

//     // Store the user in state and localStorage
//     setUser(loggedInUser);
//     localStorage.setItem("user", JSON.stringify(loggedInUser));

//     return true;
//   };

//   const logout = () => {
//     setUser(null);
//     localStorage.removeItem("user"); // Clear stored session
//   };

//   return (
//     <AuthContext.Provider value={{ user, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };
// export const useAuth = () => useContext(AuthContext);
// // export default AuthContext;
import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const login = (username, password) => {
  const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
  const TUTOR_PASSWORD = process.env.REACT_APP_TUTOR_PASSWORD;
  const WARDEN_PASSWORD = process.env.REACT_APP_WARDEN_PASSWORD;

  // 🔥 strict username + password matching

  if (username === "admin" && password === ADMIN_PASSWORD) {
    const userData = { role: "admin", username };
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    return true;
  }

  if (username === "tutor" && password === TUTOR_PASSWORD) {
    const userData = { role: "tutor", username };
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    return true;
  }

  if (username === "warden" && password === WARDEN_PASSWORD) {
    const userData = { role: "warden", username };
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
    return true;
  }

  return false;
};

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};